/**
 * Who sees which approval queue, and who gets the decide buttons (design
 * §4.21.13; S14, S17, S19). Pure, so Vitest can reach it. UX only: the server
 * refuses a decision from anybody it does not address (§7.2).
 */

/**
 * S14: the Material tab is for a gate-out or disposal approver, and for a
 * project manager who has a pass addressed to them without holding either.
 */
export const showMaterialTab = (opts: {
  holdsGateOutApprove: boolean;
  holdsDisposalApprove: boolean;
  addressedGateOuts: number;
}) => opts.holdsGateOutApprove || opts.holdsDisposalApprove || opts.addressedGateOuts > 0;

/** S17: quarantine decisions are approved with the gate-out right (J2). */
export const showQuarantineTab = (holdsGateOutApprove: boolean) => holdsGateOutApprove;

/** S17: a write-off has its own approval right (J3). */
export const showDisposalsTab = (holdsDisposalApprove: boolean) => holdsDisposalApprove;

/**
 * S19: the Approvals route and nav entry. Permission holders, plus anybody with
 * a day waiting on them or an open project to manage, who hold no approval
 * permission at all.
 */
export const approvalsAdmitted = (opts: {
  holdsApprovalPermission: boolean;
  awaitingCount: number;
  managesProject: boolean;
}) => opts.holdsApprovalPermission || opts.awaitingCount > 0 || opts.managesProject;

/**
 * S14: Approve and Reject on a pass. The server says whether this user may
 * decide (`can_decide`); an older server does not, so fall back to the right.
 */
export const gateOutCanDecide = (
  pass: { pending_approval: unknown; can_decide?: boolean | null },
  holdsGateOutApprove: boolean,
): boolean => Boolean(pass.pending_approval) && (pass.can_decide ?? holdsGateOutApprove);
